import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { SurveyVariableConditionSectionTypeEnum } from 'src/app/enums/survey-variable-condition-section-type.enum';

@Component({
  selector: 'app-add-survey-section-dialog',
  templateUrl: './add-survey-section-dialog.component.html',
  styleUrl: './add-survey-section-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatButtonModule],
})
export class AddSurveySectionDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<AddSurveySectionDialogComponent, SurveyVariableConditionSectionTypeEnum | undefined>);

  readonly options = ADD_SURVEY_SECTION_OPTIONS;

  selectOption(type: SurveyVariableConditionSectionTypeEnum): void {
    this.dialog_ref.close(type);
  }
}

interface AddSurveySectionOption {
  type: SurveyVariableConditionSectionTypeEnum;
  title: string;
  badge_label: string;
  description: string;
}

const ADD_SURVEY_SECTION_OPTIONS: readonly AddSurveySectionOption[] = [
  {
    type: SurveyVariableConditionSectionTypeEnum.Free,
    title: 'Preguntas Libres',
    badge_label: 'Preguntas Libres',
    description: 'Este tipo de sección podrá generar unas preguntas simples para el usuario que está contestando.',
  },
  {
    type: SurveyVariableConditionSectionTypeEnum.Product,
    title: 'Preguntas por Productos y/o Trabajadores',
    badge_label: 'Productos y/o Trabajadores',
    description:
      'Este tipo de sección generará, según configuración, preguntas por productos, preguntas por trabajadores y/o preguntas sobre los distintos compañeros en un producto y su desempeño. Se podrán añadir secciones de autoevaluación y de habilidades específicas.',
  },
  {
    type: SurveyVariableConditionSectionTypeEnum.Skills,
    title: 'Preguntas por Habilidades y Tecnologías',
    badge_label: 'Habilidades y Tecnologías',
    description:
      'Esta sección generará automáticamente preguntas para cada usuario que recibe la encuesta, preguntando por cada uno de sus compañeros, y generando una pregunta de nivel por habilidad que está asociada con su rol.',
  },
];

export function getSurveySectionType(type: SurveyVariableConditionSectionTypeEnum): AddSurveySectionOption {
  switch (type) {
    case SurveyVariableConditionSectionTypeEnum.Free:
      return ADD_SURVEY_SECTION_OPTIONS[0];
    case SurveyVariableConditionSectionTypeEnum.Product:
    case SurveyVariableConditionSectionTypeEnum.Worker:
    case SurveyVariableConditionSectionTypeEnum.ProductByWorker:
      return ADD_SURVEY_SECTION_OPTIONS[1];
    case SurveyVariableConditionSectionTypeEnum.Skills:
      return ADD_SURVEY_SECTION_OPTIONS[2];
  }
}
